import { format } from "date-fns";
import { saveAs } from "file-saver";

import { DATE_FORMATS_FNS } from "components";
import ENV from "config/Env";
import { useTypedMutation } from "hooks";
import { ApiInstance } from "utils/Api";

import type { DevicePayload } from "modules/DevicesDashboard/queryKeys";

export const useExportDevicesMutation = () =>
  useTypedMutation<DevicePayload, string>({
    mutationFn: async payload => (await ApiInstance.post("/devices/export", payload, ENV.systemBaseURL)).data.url,
    onSuccess: (_, url) => saveAs(url, `Tablets_${format(new Date(), DATE_FORMATS_FNS.yearMonthDate)}.csv`)
  });
